// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mergeConfigs = (stateConfig: any, propsConfig: any) => {
    const { searchConfig = {}, ...restOfStateConfig } = stateConfig;

    return {
        ...searchConfig,
        ...restOfStateConfig,
        ...propsConfig
    };
};
